import React, { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Cookies from 'js-cookie';

import {
  Login,
  Register,
  Recovery,
  RecoveryPassword,
  Profile,
  Feedback,
  People,
  Error,
  MyPeople,
  StoryPage
} from "@pages";
import { useAppDispatch, useAppSelector, fetchProfile } from 'store';
import { ProtectedRoute } from "utils";
import 'react-toastify/dist/ReactToastify.css';

import { GlobalStyle, LanguageButton, LanguageContainer, Loader, Loading } from "./globalStyles";
import { useTranslation } from 'react-i18next';
import MainPage from "./pages/Main/main";
import PrivacyPolicy from "./pages/Policy/policy";


const App: React.FC = () => {
  const dispatch = useAppDispatch();
  const {i18n} = useTranslation();
  const {profile, loading} = useAppSelector((state) => state.profile);
  const localLang = localStorage.getItem("i18next");
  const [language, setLanguage] = React.useState(localLang || "ru");

  const toggleLanguage = () => {
    const newLang = language === "ru" ? "en" : "ru"
    setLanguage(newLang);
    i18n.changeLanguage(newLang);
    localStorage.setItem("i18next", newLang)
  };

  useEffect(() => {
    const accessToken = Cookies.get('access');
    if (accessToken && !profile) dispatch(fetchProfile());
  }, [dispatch, profile])

  useEffect(() => {
    if (!localLang) localStorage.setItem("i18next", localLang || "ru")
    i18n.changeLanguage(localLang || "ru");
  }, [])

  return (
    <Router>
      <LanguageContainer className='languageContainer'>
        <LanguageButton onClick={toggleLanguage}>
          {language === "en" ? "EN" : "RUS"}
        </LanguageButton>
      </LanguageContainer>
      <Loader loading={loading}>
        <Loading/>
      </Loader>
      <GlobalStyle/>
      <ToastContainer/>
      <Routes>
        <Route path="/" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
        <Route path="/stories" element={<ProtectedRoute><People/></ProtectedRoute>} />

        <Route path="/stories/:id" element={<ProtectedRoute><StoryPage /></ProtectedRoute>}/>
        <Route path="/my-stories" element={<ProtectedRoute><MyPeople/></ProtectedRoute>}>
          <Route path="/my-stories/:id" element={<ProtectedRoute><MyPeople/></ProtectedRoute>}/>
        </Route>
        <Route path="/login" element={<Login/>}/>
        <Route path="/register" element={<Register/>}/>
        <Route path="/register-check-email" element={<Register.CheckEmail/>}/>
        <Route path="/feedback" element={<ProtectedRoute><Feedback/></ProtectedRoute>}/>
        <Route path="/recovery" element={<Recovery/>}/>
        <Route path="/recovery-password" element={<RecoveryPassword/>}/>
        <Route path="/recovery-check-email" element={<Recovery.CheckRecovery/>}/>
        <Route path="/profile" element={<ProtectedRoute><Profile/></ProtectedRoute>}/>
        <Route path="/policy" element={<ProtectedRoute><PrivacyPolicy/></ProtectedRoute>}/>
        <Route path="*" element={<Error/>}/>
      </Routes>
    </Router>
  );
};

export default App;
